export const AuthenticationTexts = {
  smsCaption: 'Введите код из СМС',
  smsDescription: 'Мы отправили СМС с кодом подтверждения на номер',
  changeNumber: 'Изменить номер телефона',
  smsCodeInputLabel: 'СМС код',
  errorTitle: 'Что-то пошло не так :(',
  errorDescription: 'Не удалось загрузить данные профиля. Попробуйте перезагрузить страницу',
};
